import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "text-subtitle2 ellipsis" }
const _hoisted_3 = { class: "text-h4" }

import SfxBtnIcon from "src/components/button/SfxBtnIcon.vue"
import SfxCard from "src/components/card/SfxCard.vue"
import SfxDataPoint from "src/components/data-point/SfxDataPoint.vue"
import { useCacheStore } from "src/stores/cacheStore"
import { SFX_CARD_CONDENSED_HEIGHT } from "src/util/constants/configurations"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { getAttachmentContent } from "src/util/functions/attachments"
import { getIssuePriorityColor } from "src/util/functions/issuePriority"
import { IconRowElement } from "src/util/types/components/sfxIconRow"
import { ItemCardData } from "src/util/types/dataModels/item"
import { ItemClass } from "src/util/types/dataModels/itemClass"
import { computed, PropType, ref, watch } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxCardWorkOrderItemCondensed',
  props: {
  item: {
    type: Object as PropType<ItemCardData>,
    required: true,
  },

  // If the card has closable set to true, then it would have the X/Remove icon on the top right.
  closable: {
    type: Boolean,
    default: () => false,
  },

  // If performed is true, then add the green border and background, and all additional icons.
  performed: {
    type: Boolean,
    default: () => false,
  },
},
  emits: ["clickClose"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

const cacheStore = useCacheStore()
const storeItem = ref<ItemCardData>()

const itemClassRaw = ref<ItemClass | undefined>(props.item.itemClassData)
const itemThumbnailRaw = ref(props.item.thumbnail)

const itemThumbnail = ref<string | undefined>()
const itemClassDesignation = computed(() => itemClassRaw.value?.designation)
const iconRow = ref<IconRowElement[]>([])
const workDone = computed(() => props.item?.regularWork?.conclusion === "accepted")
const cardClasses = computed(() => {
  return {
    "sfx-card-work-order-entity-condensed__performed": props.performed,
    "sfx-card-work-order-entity-condensed__accepted": props.performed && workDone.value,
  }
})

//endregion

//region Functions

function assignData(item: ItemCardData) {
  storeItem.value = cacheStore.itemCard.get(item.itemData.id)

  assignItemClass(item)
  iconRow.value = getIconRow(item)
  assignThumbnail(item)
}

function assignItemClass(item: ItemCardData) {
  // We already have the data so skip it
  if (itemClassRaw.value) return

  const itemClass = cacheStore.item_class.get(item.itemData.item_class)

  itemClassRaw.value = itemClass

  if (storeItem.value) storeItem.value.itemClassData = itemClass
}

async function assignThumbnail(item: ItemCardData) {
  // We already have the data so skip it
  if (itemThumbnailRaw.value !== undefined) return

  // There is no image, so no point continuing
  if (item.itemData.main_image === null) return

  const attachment = cacheStore.attachment.get(item.itemData.main_image)

  if (attachment) {
    itemThumbnailRaw.value = attachment

    if (storeItem.value) storeItem.value.thumbnail = attachment
  }
}

function getIconRow(item: ItemCardData) {
  // If the item is NOT performed:

  // From left to right, the icon order is:
  // 1. Highest Issue priority

  // If the item IS performed:

  // From left to right, the icon order is:
  // 1. Highest Issue priority
  // 2. Regular Work Icon
  // 3. Tick mark (if work done)

  const iconRow: IconRowElement[] = []
  iconRow.push({
    name: Icons.ISSUE,
    color: Boolean(item.issuePriorityData)
      ? getIssuePriorityColor(item.issuePriorityData![0])
      : undefined,
  })

  if (props.performed) {
    iconRow.push(
      {
        name: Icons.WORK_REGULAR,
        color: "fun-label-and-icon",
      },
      {
        name: Icons.TICK,
        color: workDone.value ? "positive" : undefined,
      }
    )
  }

  return iconRow
}

function handleClose() {
  emit("clickClose")
}

//endregion

//region Setup Code

watch(
  () => itemThumbnailRaw.value,
  async (thumbnail) => {
    itemThumbnail.value = thumbnail
      ? await getAttachmentContent(thumbnail, "item", props.item?.itemData.id)
      : undefined
  },
  { immediate: true }
)

watch(
  () => props.item,
  (newItem) => {
    assignData(newItem)
  },
  { immediate: true }
)

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!
  const _directive_truncate_middle = _resolveDirective("truncate-middle")!

  return (_openBlock(), _createBlock(SfxCard, _mergeProps({ clickable: "" }, _ctx.$attrs, {
    class: ["sfx-card-work-order-entity-condensed q-my-md", cardClasses.value],
    "icon-row": iconRow.value,
    height: _unref(SFX_CARD_CONDENSED_HEIGHT),
    "img-src": itemThumbnail.value,
    hasImg: ""
  }), {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(itemClassDesignation.value), 1),
        (props.closable)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_q_space),
              _createVNode(SfxBtnIcon, {
                icon: _unref(Icons).CLOSE,
                onClick: _withModifiers(handleClose, ["exact","stop"]),
                padding: "none",
                class: "sfx-card__top-right-close-button"
              }, null, 8, ["icon"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [
        [_directive_truncate_middle, props.item?.itemData.designation]
      ]),
      _createVNode(SfxDataPoint, {
        label: _ctx.$t('sfxCard.item_id'),
        "card-field": ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.item.itemData.item_id), 1)
        ]),
        _: 1
      }, 8, ["label"])
    ]),
    _: 1
  }, 16, ["class", "icon-row", "height", "img-src"]))
}
}

})